module.exports = __webpack_public_path__ + "static/media/btg_09.cc433037.png";